export const emptyObject = (obj?: any) => {
  return !obj || Object.values(obj).every(value => value === undefined || value === null || value === '' )
}